import React from 'react';
import { ButtonGroup, Table } from 'reactstrap';
import File from './File';
import ButtonAction from './ButtonAction';
import ButtonDelete from './ButtonDelete';
import HelpPopover from './HelpPopover';
import ShortDescriptions from './ShortDescriptions';
import Log from './Log';
import { FILE_TYPES, STATISTICS, CHECKS } from '../constants/Fixtures';
import ReactCSSTransition from 'react-transition-group/CSSTransition';

export default class FileTypeGroup extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      details: false,
      loading: false,
    };
  }

  toggleDetails = () => {
    this.setState({ details: !this.state.details });
  }

  getFileGroup() {
    return this.props.fileGroup || [];
  }

  typeSpecificColumns = () => {
    if (this.props.type === 'image') {
      return ['Thumbnail', 'Dimensions', 'Short Description', 'Cover'];
    } else if (this.hasStats()) {
      return ['Checks', 'Stats'];
    } else if (this.props.type == 'ebook') {
      return ['Version', 'Checks'];
    } else if (this.hasChecks()) {
      return ['Checks'];
    }
    return [];
  }

  hasStats() {
    return STATISTICS.indexOf(this.props.type) > -1;
  }

  hasChecks() {
    return CHECKS.indexOf(this.props.type) > -1;
  }

  getColumns() {
    if (this.state.details) {
      return ['Size', 'Origin', 'Modified'];
    }
    return this.typeSpecificColumns();
  }

  destroyAllFiles = () => {
    this.setState({ loading: true });
    const ids = this.getFileGroup().map(f => f.id);
    this.props.destroyGroup(ids);
  }

  hiddenColumnNames = () => this.hasStats() ? 'Checks and Stats' : 'Basic Info'

  formattedColumnName = (name) => {
    if (name === 'Short Description') {
      return (<ShortDescriptions
        updateDescrips={this.props.updateGroup}
        files={this.getFileGroup().map(f => f)}
      />);
    }
    return name;
  }

  //mobiWarning doesn't get called. Remove function after mid-2021 as obsolete.
  mobiWarning(){
    const depWarning = (
      <div>
        <p>Amazon no longer recommends producing MOBI files for distribution through their platform. The recommended file to provide to Amazon is ePub{'\u00A0'}3. You are encouraged to use Amazon's Kindle Previewer tool to emulate the appearance of your ebooks on Kindle devices.</p>
        <p>In accordance with this change, Scribe will remove the ability to generate MOBI files through the Digital Hub starting March{'\u00A0'}1,{'\u00A0'}2021. You can direct questions about this change to <a href="mailto:support@scribenet.com">support@scribenet.com</a>.</p>
      </div>);
    if (this.props.type == 'ebook'){
      return(
        <Log
          color
          time=""
          heading="warning"
          message={depWarning}
        />
      );
    }
  }

  render() {
    const cols = this.getColumns();
    const category = this.props.category;
    const altColType = this.state.details ? this.hiddenColumnNames() : 'Details';

    return (<div style={{ position: 'relative' }}>
      <Table className={`file-group file-group-${this.props.type}`} striped hover responsive>
        <thead>
          <tr className="file-group-head">
            <th
              className="file-category"
              colSpan={cols.length + 2}
            >
              {category} files
              <ButtonGroup className="file-group-actions">
                <ButtonAction
                  id="details-toggle"
                  icon="fa-info-circle"
                  action={this.toggleDetails}
                  title={`Show ${altColType.toLowerCase()} for ${category.toLowerCase()} files`}
                >
                  <span className="hidden-sm-down">{altColType}</span>
                </ButtonAction>
                {this.hasStats() ?
                  <ButtonAction
                    icon="fa-external-link"
                    color="secondary"
                    action={() => this.props.getGroupStatistics(this.props.type)}
                    title={`Show statistics for ${category.toLowerCase()} files`}
                  >
                    <span className="hidden-sm-down">Group Stats</span>
                  </ButtonAction> : null}
                  <a
                    className="btn btn-secondary"
                    title={`Download all ${category.toLowerCase()} files`}
                    data-turbolinks={false}
                    href={`/get/projects/${this.props.projectId}/${this.props.type}`}
                  >
                    <i className="fa fa-download" />
                  </a>
                  <ButtonDelete
                    key={`${category}-del`}
                    title={`Delete all ${category} files`}
                    action={this.destroyAllFiles}
                    noConfirm={this.props.noConfirm}
                  />
                </ButtonGroup>
              </th>
            </tr>
            <tr id="file-group-cols">
              <th>Name</th>
              {cols.map(col =>
                  (<th key={col}>
                    {this.formattedColumnName(col)}
                  </th>),
              )}
              <th>&nbsp;</th>
            </tr>
          </thead>
          <ReactCSSTransition
            classNames="list-fold"
            timeout={{ enter: 500, exit: 500 }}>
              <tbody>
              {this.getFileGroup().map((file, index) =>
                  (<File
                    {...file}
                    key={`file-${file.id || index}`}
                    destroy={() => this.props.destroy(file.id)}
                    update={this.props.update}
                    columns={cols}
                    getStatistics={this.props.getStatistics}
                    getChecks={this.props.getChecks}
                    cover={this.props.cover}
                    projectUpdate={this.props.projectUpdate}
                  />),
              )}
              </tbody>
          </ReactCSSTransition>
      </Table>
      {this.state.loading ? <div className="loading-overlay">&nbsp;</div> : null }
    </div>);
  }
}
